


















import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
} from '@vue/composition-api'

import ExportImportButton from '@/components/molecules/h/ExportImportButton.vue'
import TitleAndManipulate from '@/components/organisms/h/TitleAndManipulate.vue'

export default defineComponent({
  components: {
    TitleAndManipulate,
    ExportImportButton,
  },
  setup(_, context) {
    const instance = getCurrentInstance()
    if (!instance) {
      // should be called in setup
      return
    }
    const { $i18n } = instance.proxy

    const requestExport = () => {
      context.emit('request-export')
    }
    const requestImport = () => {
      context.emit('request-import')
    }

    return {
      requestExport,
      requestImport,
    }
  },
})
